import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getAssetUrl as e } from "../assets.js";
import t from "../core/has.js";
var o,
    r = null;

function n() {
  return !!r;
}

function _() {
  return !!t("esri-wasm");
}

function P() {
  return o || (o = import("./pe-wasm.js").then(function (e) {
    return e.p;
  }).then(function (_ref) {
    var t = _ref.default;
    return t({
      locateFile: function locateFile(t) {
        return e("esri/geometry/support/".concat(t));
      }
    });
  }).then(function (e) {
    N(e);
  }), o);
}

var s, E, i;
!function (e) {
  function t(e, t, o) {
    r.ensureCache.prepare();

    var n = A(o),
        _ = o === n,
        P = r.ensureFloat64(n),
        s = r._pe_geog_to_proj(r.getPointer(e), t, P);

    return s && d(o, t, P, _), s;
  }

  function o(e, o, r, _) {
    switch (_) {
      case E.PE_TRANSFORM_P_TO_G:
        return n(e, o, r);

      case E.PE_TRANSFORM_G_TO_P:
        return t(e, o, r);
    }

    return 0;
  }

  function n(e, t, o) {
    return _(e, t, o, 0);
  }

  function _(e, t, o, n) {
    r.ensureCache.prepare();

    var _ = A(o),
        P = o === _,
        s = r.ensureFloat64(_),
        E = r._pe_proj_to_geog_center(r.getPointer(e), t, s, n);

    return E && d(o, t, s, P), E;
  }

  e.geogToProj = t, e.projGeog = o, e.projToGeog = n, e.projToGeogCenter = _;
}(s || (s = {})), function (e) {
  function t() {
    e.PE_BUFFER_MAX = r.PeDefs.prototype.PE_BUFFER_MAX, e.PE_NAME_MAX = r.PeDefs.prototype.PE_NAME_MAX, e.PE_MGRS_MAX = r.PeDefs.prototype.PE_MGRS_MAX, e.PE_USNG_MAX = r.PeDefs.prototype.PE_USNG_MAX, e.PE_DD_MAX = r.PeDefs.prototype.PE_DD_MAX, e.PE_DDM_MAX = r.PeDefs.prototype.PE_DDM_MAX, e.PE_DMS_MAX = r.PeDefs.prototype.PE_DMS_MAX, e.PE_UTM_MAX = r.PeDefs.prototype.PE_UTM_MAX, e.PE_PARM_MAX = r.PeDefs.prototype.PE_PARM_MAX, e.PE_TYPE_NONE = r.PeDefs.prototype.PE_TYPE_NONE, e.PE_TYPE_GEOGCS = r.PeDefs.prototype.PE_TYPE_GEOGCS, e.PE_TYPE_PROJCS = r.PeDefs.prototype.PE_TYPE_PROJCS, e.PE_TYPE_GEOGTRAN = r.PeDefs.prototype.PE_TYPE_GEOGTRAN, e.PE_TYPE_COORDSYS = r.PeDefs.prototype.PE_TYPE_COORDSYS, e.PE_TYPE_UNIT = r.PeDefs.prototype.PE_TYPE_UNIT, e.PE_TYPE_LINUNIT = r.PeDefs.prototype.PE_TYPE_LINUNIT, e.PE_STR_OPTS_NONE = r.PeDefs.prototype.PE_STR_OPTS_NONE, e.PE_STR_AUTH_NONE = r.PeDefs.prototype.PE_STR_AUTH_NONE, e.PE_STR_AUTH_TOP = r.PeDefs.prototype.PE_STR_AUTH_TOP, e.PE_STR_NAME_CANON = r.PeDefs.prototype.PE_STR_NAME_CANON, e.PE_PARM_X0 = r.PeDefs.prototype.PE_PARM_X0, e.PE_PARM_ND = r.PeDefs.prototype.PE_PARM_ND, e.PE_TRANSFORM_1_TO_2 = r.PeDefs.prototype.PE_TRANSFORM_1_TO_2, e.PE_TRANSFORM_2_TO_1 = r.PeDefs.prototype.PE_TRANSFORM_2_TO_1, e.PE_TRANSFORM_P_TO_G = r.PeDefs.prototype.PE_TRANSFORM_P_TO_G, e.PE_TRANSFORM_G_TO_P = r.PeDefs.prototype.PE_TRANSFORM_G_TO_P, e.PE_HORIZON_RECT = r.PeDefs.prototype.PE_HORIZON_RECT, e.PE_HORIZON_POLY = r.PeDefs.prototype.PE_HORIZON_POLY, e.PE_HORIZON_LINE = r.PeDefs.prototype.PE_HORIZON_LINE, e.PE_HORIZON_DELTA = r.PeDefs.prototype.PE_HORIZON_DELTA;
  }

  e.init = t;
}(E || (E = {})), function (e) {
  var t = {},
      o = {},
      n = function n(e) {
    if (e) {
      var _t = e.getType();

      switch (_t) {
        case E.PE_TYPE_GEOGCS:
          e = r.castObject(e, r.PeGeogcs);
          break;

        case E.PE_TYPE_PROJCS:
          e = r.castObject(e, r.PeProjcs);
          break;

        case E.PE_TYPE_GEOGTRAN:
          e = r.castObject(e, r.PeGeogtran);
          break;

        default:
          _t & E.PE_TYPE_UNIT && (e = r.castObject(e, r.PeUnit));
      }
    }

    return e;
  };

  function _() {
    r.PeFactory.prototype.initialize(null);
  }

  function P(e) {
    return s(E.PE_TYPE_COORDSYS, e);
  }

  function s(e, o) {
    var _ = null,
        P = t[e];
    if (P || (P = {}, t[e] = P), P.hasOwnProperty(String(o))) _ = P[o];else {
      var _t2 = r.PeFactory.prototype.factoryByType(e, o);

      r.compare(_t2, r.NULL) || (_ = _t2, P[o] = _);
    }
    return _ = n(_), _;
  }

  function i(e, t) {
    var _ = null,
        P = o[e];
    if (P || (P = {}, o[e] = P), P.hasOwnProperty(t)) _ = P[t];else {
      var _o = r.PeFactory.prototype.fromString(e, t);

      r.compare(_o, r.NULL) || (_ = _o, P[t] = _);
    }
    return _ = n(_), _;
  }

  function p(e) {
    return s(E.PE_TYPE_GEOGCS, e);
  }

  function u(e) {
    return s(E.PE_TYPE_GEOGTRAN, e);
  }

  function c(e) {
    return r.PeFactory.prototype.getCode(e);
  }

  function a(e) {
    return s(E.PE_TYPE_PROJCS, e);
  }

  function g(e) {
    return s(E.PE_TYPE_UNIT, e);
  }

  e.initialize = _, e.coordsys = P, e.factoryByType = s, e.fromString = i, e.geogcs = p, e.geogtran = u, e.getCode = c, e.projcs = a, e.unit = g;
}(i || (i = {}));
var p = null;
var u, c, a, g, T, f, O, S, l;

function N(e) {
  function t(e, t, o) {
    e[t] = o(e[t]);
  }

  r = e, E.init(), u.init(), T.init(), O.init(), S.init(), p = /*#__PURE__*/function (_r$PeGCSExtent) {
    _inherits(p, _r$PeGCSExtent);

    var _super = _createSuper(p);

    function p() {
      _classCallCheck(this, p);

      return _super.apply(this, arguments);
    }

    _createClass(p, [{
      key: "destroy",
      value: function destroy() {
        r.destroy(this);
      }
    }]);

    return p;
  }(r.PeGCSExtent);
  var o = [r.PeDatum, r.PeGeogcs, r.PeGeogtran, r.PeObject, r.PeParameter, r.PePrimem, r.PeProjcs, r.PeSpheroid, r.PeUnit];

  for (var _i = 0, _o2 = o; _i < _o2.length; _i++) {
    var _r = _o2[_i];
    t(_r.prototype, "getName", function (e) {
      return function () {
        return e.call(this, new Array(E.PE_NAME_MAX));
      };
    });
  }

  for (var _i2 = 0, _arr = [r.PeGeogtran, r.PeProjcs]; _i2 < _arr.length; _i2++) {
    var _P = _arr[_i2];
    t(_P.prototype, "getParameters", function (e) {
      return function () {
        var t = new Array(E.PE_PARM_MAX);
        var o = e.call(this);

        for (var _e = 0; _e < t.length; _e++) {
          var _n = r.getValue(o, "*");

          t[_e] = _n ? r.wrapPointer(_n, r.PeParameter) : null, o += Int32Array.BYTES_PER_ELEMENT;
        }

        return t;
      };
    });
  }

  t(r.PeHorizon.prototype, "getCoord", function (e) {
    return function () {
      var t = this.getSize();
      if (!t) return null;
      var o = [];
      return d(o, t, e.call(this)), o;
    };
  }), t(r.PeGTlistExtendedEntry.prototype, "getEntries", function (e) {
    var t = r._pe_getPeGTlistExtendedGTsSize();

    return function () {
      var o = null;
      var n = e.call(this);

      if (!r.compare(n, r.NULL)) {
        o = [n];

        var _e2 = this.getSteps();

        if (_e2 > 1) {
          var _2 = r.getPointer(n);

          for (var _n2 = 1; _n2 < _e2; _n2++) {
            o.push(r.wrapPointer(_2 + t * _n2, r.PeGTlistExtendedGTs));
          }
        }
      }

      return o;
    };
  });

  var n = r._pe_getPeHorizonSize(),
      _ = function _(e) {
    return function () {
      var t = this._cache;
      if (t || (t = new Map(), this._cache = t), t.has(e)) return t.get(e);
      var o = null;

      var _ = e.call(this);

      if (!r.compare(_, r.NULL)) {
        o = [_];

        var _e3 = _.getNump();

        if (_e3 > 1) {
          var _t3 = r.getPointer(_);

          for (var _3 = 1; _3 < _e3; _3++) {
            o.push(r.wrapPointer(_t3 + n * _3, r.PeHorizon));
          }
        }
      }

      return t.set(e, o), o;
    };
  };

  t(r.PeProjcs.prototype, "horizonGcsGenerate", _), t(r.PeProjcs.prototype, "horizonPcsGenerate", _), r.PeObject.prototype.toString = function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : E.PE_STR_OPTS_NONE;
    r.ensureCache.prepare();
    var t = r.getPointer(this),
        o = r.ensureInt8(new Array(E.PE_BUFFER_MAX));
    return r.UTF8ToString(r._pe_object_to_string_ext(t, e, o));
  };
}

function y(e) {
  if (!e) return;
  var t = r.getClass(e);
  if (!t) return;
  var o = r.getCache(t);
  if (!o) return;
  var n = r.getPointer(e);
  n && delete o[n];
}

function M(e, t) {
  var o = [],
      n = new Array(t);

  for (var _4 = 0; _4 < e; _4++) {
    o.push(r.ensureInt8(n));
  }

  return o;
}

function A(e) {
  var t;
  return Array.isArray(e[0]) ? (t = [], e.forEach(function (e) {
    t.push(e[0], e[1]);
  })) : t = e, t;
}

function d(e, t, o) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  if (n) for (var _5 = 0; _5 < 2 * t; _5++) {
    e[_5] = r.getValue(o + _5 * Float64Array.BYTES_PER_ELEMENT, "double");
  } else {
    var _n3 = 0 === e.length;

    for (var _6 = 0; _6 < t; _6++) {
      _n3 && (e[_6] = new Array(2)), e[_6][0] = r.getValue(o, "double"), e[_6][1] = r.getValue(o + Float64Array.BYTES_PER_ELEMENT, "double"), o += 2 * Float64Array.BYTES_PER_ELEMENT;
    }
  }
}

!function (e) {
  var t;

  function o() {
    e.PE_GTLIST_OPTS_COMMON = r.PeGTlistExtended.prototype.PE_GTLIST_OPTS_COMMON, t = r._pe_getPeGTlistExtendedEntrySize();
  }

  function n(e, o, n, _, P, s) {
    var E = null;
    var i = new r.PeInteger(s);

    try {
      var _p = r.PeGTlistExtended.prototype.getGTlist(e, o, n, _, P, i);

      if ((s = i.val) && (E = [_p], s > 1)) {
        var _e4 = r.getPointer(_p);

        for (var _o3 = 1; _o3 < s; _o3++) {
          E.push(r.wrapPointer(_e4 + t * _o3, r.PeGTlistExtendedEntry));
        }
      }
    } finally {
      r.destroy(i);
    }

    return E;
  }

  e.init = o, e.getGTlist = n;
}(u || (u = {})), function (e) {
  function t(e) {
    if (e && e.length) {
      var _iterator = _createForOfIteratorHelper(e),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t4 = _step.value;
          y(_t4), _t4.getEntries().forEach(function (e) {
            y(e);
            var t = e.getGeogtran();
            y(t), t.getParameters().forEach(y), [t.getGeogcs1(), t.getGeogcs2()].forEach(function (e) {
              y(e);
              var t = e.getDatum();
              y(t), y(t.getSpheroid()), y(e.getPrimem()), y(e.getUnit());
            });
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      r.PeGTlistExtendedEntry.prototype.Delete(e[0]);
    }
  }

  e.destroy = t;
}(c || (c = {})), function (e) {
  function t(e, t, o, n, _) {
    r.ensureCache.prepare();
    var P = A(o),
        s = o === P,
        E = r.ensureFloat64(P);
    var i = 0;
    n && (i = r.ensureFloat64(n));

    var p = r._pe_geog_to_geog(r.getPointer(e), t, E, i, _);

    return p && d(o, t, E, s), p;
  }

  e.geogToGeog = t;
}(a || (a = {})), function (e) {
  var t = function t(e, _t5, o, n, _, P) {
    var s, i;

    switch (r.ensureCache.prepare(), e) {
      case "dd":
        s = r._pe_geog_to_dd, i = E.PE_DD_MAX;
        break;

      case "ddm":
        s = r._pe_geog_to_ddm, i = E.PE_DDM_MAX;
        break;

      case "dms":
        s = r._pe_geog_to_dms, i = E.PE_DMS_MAX;
    }

    var p = 0;
    _t5 && (p = r.getPointer(_t5));
    var u = A(n),
        c = r.ensureFloat64(u),
        a = M(o, i),
        g = s(p, o, c, _, r.ensureInt32(a));
    if (g) for (var _E = 0; _E < o; _E++) {
      P[_E] = r.UTF8ToString(a[_E]);
    }
    return g;
  },
      o = function o(e, t, _o4, n, _) {
    var P;

    switch (r.ensureCache.prepare(), e) {
      case "dd":
        P = r._pe_dd_to_geog;
        break;

      case "ddm":
        P = r._pe_ddm_to_geog;
        break;

      case "dms":
        P = r._pe_dms_to_geog;
    }

    var s = 0;
    t && (s = r.getPointer(t));
    var E = n.map(function (e) {
      return r.ensureString(e);
    }),
        i = r.ensureInt32(E),
        p = r.ensureFloat64(new Array(2 * _o4)),
        u = P(s, _o4, i, p);
    return u && d(_, _o4, p), u;
  };

  function n(e, o, r, n, _) {
    return t("dms", e, o, r, n, _);
  }

  function _(e, t, r, n) {
    return o("dms", e, t, r, n);
  }

  function P(e, o, r, n, _) {
    return t("ddm", e, o, r, n, _);
  }

  function s(e, t, r, n) {
    return o("ddm", e, t, r, n);
  }

  function i(e, o, r, n, _) {
    return t("dd", e, o, r, n, _);
  }

  function p(e, t, r, n) {
    return o("dd", e, t, r, n);
  }

  e.geog_to_dms = n, e.dms_to_geog = _, e.geog_to_ddm = P, e.ddm_to_geog = s, e.geog_to_dd = i, e.dd_to_geog = p;
}(g || (g = {})), function (e) {
  function t() {
    e.PE_MGRS_STYLE_NEW = r.PeNotationMgrs.prototype.PE_MGRS_STYLE_NEW, e.PE_MGRS_STYLE_OLD = r.PeNotationMgrs.prototype.PE_MGRS_STYLE_OLD, e.PE_MGRS_STYLE_AUTO = r.PeNotationMgrs.prototype.PE_MGRS_STYLE_AUTO, e.PE_MGRS_180_ZONE_1_PLUS = r.PeNotationMgrs.prototype.PE_MGRS_180_ZONE_1_PLUS, e.PE_MGRS_ADD_SPACES = r.PeNotationMgrs.prototype.PE_MGRS_ADD_SPACES;
  }

  function o(e, t, o, n, _, P, s) {
    r.ensureCache.prepare();
    var i = 0;
    e && (i = r.getPointer(e));

    var p = A(o),
        u = r.ensureFloat64(p),
        c = M(t, E.PE_MGRS_MAX),
        a = r.ensureInt32(c),
        g = r._pe_geog_to_mgrs_extended(i, t, u, n, _, P, a);

    if (g) for (var _E2 = 0; _E2 < t; _E2++) {
      s[_E2] = r.UTF8ToString(c[_E2]);
    }
    return g;
  }

  function n(e, t, o, n, _) {
    r.ensureCache.prepare();
    var P = 0;
    e && (P = r.getPointer(e));

    var s = o.map(function (e) {
      return r.ensureString(e);
    }),
        E = r.ensureInt32(s),
        i = r.ensureFloat64(new Array(2 * t)),
        p = r._pe_mgrs_to_geog_extended(P, t, E, n, i);

    return p && d(_, t, i), p;
  }

  e.init = t, e.geog_to_mgrs_extended = o, e.mgrs_to_geog_extended = n;
}(T || (T = {})), function (e) {
  function t(e, t, o, n, _, P, s) {
    r.ensureCache.prepare();
    var i = 0;
    e && (i = r.getPointer(e));

    var p = A(o),
        u = r.ensureFloat64(p),
        c = M(t, E.PE_MGRS_MAX),
        a = r.ensureInt32(c),
        g = r._pe_geog_to_usng(i, t, u, n, _, P, a);

    if (g) for (var _E3 = 0; _E3 < t; _E3++) {
      s[_E3] = r.UTF8ToString(c[_E3]);
    }
    return g;
  }

  function o(e, t, o, n) {
    r.ensureCache.prepare();
    var _ = 0;
    e && (_ = r.getPointer(e));

    var P = o.map(function (e) {
      return r.ensureString(e);
    }),
        s = r.ensureInt32(P),
        E = r.ensureFloat64(new Array(2 * t)),
        i = r._pe_usng_to_geog(_, t, s, E);

    return i && d(n, t, E), i;
  }

  e.geog_to_usng = t, e.usng_to_geog = o;
}(f || (f = {})), function (e) {
  function t() {
    e.PE_UTM_OPTS_NONE = r.PeNotationUtm.prototype.PE_UTM_OPTS_NONE, e.PE_UTM_OPTS_ADD_SPACES = r.PeNotationUtm.prototype.PE_UTM_OPTS_ADD_SPACES, e.PE_UTM_OPTS_NS = r.PeNotationUtm.prototype.PE_UTM_OPTS_NS;
  }

  function o(e, t, o, n, _) {
    r.ensureCache.prepare();
    var P = 0;
    e && (P = r.getPointer(e));

    var s = A(o),
        i = r.ensureFloat64(s),
        p = M(t, E.PE_UTM_MAX),
        u = r.ensureInt32(p),
        c = r._pe_geog_to_utm(P, t, i, n, u);

    if (c) for (var _E4 = 0; _E4 < t; _E4++) {
      _[_E4] = r.UTF8ToString(p[_E4]);
    }
    return c;
  }

  function n(e, t, o, n, _) {
    r.ensureCache.prepare();
    var P = 0;
    e && (P = r.getPointer(e));

    var s = o.map(function (e) {
      return r.ensureString(e);
    }),
        E = r.ensureInt32(s),
        i = r.ensureFloat64(new Array(2 * t)),
        p = r._pe_utm_to_geog(P, t, E, n, i);

    return p && d(_, t, i), p;
  }

  e.init = t, e.geog_to_utm = o, e.utm_to_geog = n;
}(O || (O = {})), function (e) {
  var t = new Map();

  function o() {
    e.PE_PCSINFO_OPTION_NONE = r.PePCSInfo.prototype.PE_PCSINFO_OPTION_NONE, e.PE_PCSINFO_OPTION_DOMAIN = r.PePCSInfo.prototype.PE_PCSINFO_OPTION_DOMAIN, e.PE_POLE_OUTSIDE_BOUNDARY = r.PePCSInfo.prototype.PE_POLE_OUTSIDE_BOUNDARY, e.PE_POLE_POINT = r.PePCSInfo.prototype.PE_POLE_POINT;
  }

  function n(o) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.PE_PCSINFO_OPTION_DOMAIN;

    var _, P;

    return t.has(o) && (P = t.get(o), P[n] && (_ = P[n])), _ || (_ = r.PePCSInfo.prototype.generate(o, n), P || (P = [], t.set(o, P)), P[n] = _), _;
  }

  e.init = o, e.generate = n;
}(S || (S = {})), function (e) {
  function t() {
    return r.PeVersion.prototype.version_string();
  }

  e.version_string = t;
}(l || (l = {}));
var R = Object.freeze({
  __proto__: null,

  get _pe() {
    return r;
  },

  isLoaded: n,
  isSupported: _,
  load: P,

  get PeCSTransformations() {
    return s;
  },

  get PeDefs() {
    return E;
  },

  get PeFactory() {
    return i;
  },

  get PeGCSExtent() {
    return p;
  },

  get PeGTlistExtended() {
    return u;
  },

  get PeGTlistExtendedEntry() {
    return c;
  },

  get PeGTTransformations() {
    return a;
  },

  get PeNotationDms() {
    return g;
  },

  get PeNotationMgrs() {
    return T;
  },

  get PeNotationUsng() {
    return f;
  },

  get PeNotationUtm() {
    return O;
  },

  get PePCSInfo() {
    return S;
  },

  get PeVersion() {
    return l;
  },

  _init: N
});
export { g as P, r as _, _ as a, T as b, f as c, O as d, i as e, E as f, s as g, p as h, n as i, u as j, c as k, P as l, a as m, S as n, l as o, R as p, N as q };